module.exports = __webpack_public_path__ + "fonts/CircularStd-Book.6365c40a.otf";